import { render, staticRenderFns } from "./AccountReceivable.vue?vue&type=template&id=e46cc4b8&"
import script from "./AccountReceivable.vue?vue&type=script&lang=js&"
export * from "./AccountReceivable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports